import { DateField, TextField } from "react-admin";

import Card from "./Card";
import EditButton from "../components/buttons/EditButton";
import Filters from "./Filters";
import React from "react";
import ResponsiveGridWithWebsocket from "../components/list/ResponsiveGridWithWebsocket";
import ResponsiveList from "../components/list/ResponsiveList";
import { useRowHighlightTracking } from "../components/utils/useRowHighlightTracking";

const List = (props) => {
  const { sentinel: highlightedSentinelIds = [] } = useRowHighlightTracking(); // <----- MODIFICALO

  const rowClass = (record) => {
    const id = record.id?.toString();
    if (highlightedSentinelIds.includes(id)) return "modifyResource";
    return "";
  };

  return (
    <ResponsiveList
      {...props}
      split
      type="table"
      filters={<Filters />}
      key={highlightedSentinelIds.join(",")}
    >
      <ResponsiveGridWithWebsocket
        target="sentinel"
        rowBreakpoint="md"
        cardContent={<Card />}
        rowClasses={rowClass}
      >
        <TextField source="id" />
        <TextField source="local_ip_address" />
        <TextField source="name" />
        <TextField source="client_version" />
        <DateField source="modified" showTime />
        <EditButton />
      </ResponsiveGridWithWebsocket>
    </ResponsiveList>
  );
};
export default List;
